const ErrorPage = () => import('./ErrorPage.vue');

const routes = [
  {
    path: '/error/:status',
    name: 'error-page',
    component: ErrorPage,
    omitFromNav: true,
  },
];

export default routes;
